import React from "react";
import { Table } from "react-bootstrap";
import Loading from "../../../components/loading";
import NoData from "../../components/noData";
import moment from "moment";
import { Tooltip } from "antd";
import { CiRead } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
// import moment from "moment";

const CardDetailsComponent = ({ isLoading, jobData }: any) => {
    const navigate = useNavigate();
  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : jobData?.card?.length ? (
        <>
          <Table bordered hover>
            <thead>
              <tr style={{ backgroundColor: "#08493e", color: "#fff" }}>
                <th className="table-th">Card No</th>
                <th className="table-th">Name</th>
                <th className="table-th">Phone</th>
                <th className="table-th">Expiry Date</th>
                <th className="table-th">Balance</th>
                <th className="table-th">reference</th>
                <th className="table-th">Acton</th>
              </tr>
            </thead>
            <tbody>
              {jobData?.card?.map((val: any, index: number) => (
                <tr key={index}>
                  <td>{val?.cardNo}</td>
                  <td>{val?.name}</td>
                  <td>{val?.phone}</td>
                  <td>{moment(val?.expiryDate).format("DD-MM-YYYY")}</td>
                  <td>{val?.balance}</td>
                  <td>{val?.reference}</td>
                  <td className="text-center">
                    <Tooltip title="View" mouseEnterDelay={0.5} color="#8f8e8d">
                      <CiRead
                        size={20}
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={()=> navigate(`/Auth/CardsDetails/${val?.id}`,{state:{val}})}

                      />
                    </Tooltip>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default CardDetailsComponent;
